import App from './App.svelte';
import wasm from './rustmod/Cargo.toml';

const init = async () => {
	const rustmod = await wasm();

	const app = new App({
		target: document.body,
		props: {
			rustmod: rustmod
		}
	});
};

init();